import Request from "./Request";

class DashboardApi {

  static stats(){
    return new Request("/dashboard/stats")
  }
}

export default DashboardApi;



// WEBPACK FOOTER //
// ./src/components/utils/DashboardApi.js